import { TestPage } from 'pages';

/* import {
  TestPage,
} from "../pages"; */
import {
  routingAccounts,
  routingCash,
  routingContractor,
  routingDictionary,
  routingEmployees,
  routingMaterialFlow,
  routingNomenclature,
  routingSalary,
  routingSecurity,
  routingTask,
} from './routes';

export const routing = [
  {
    path: '/test',
    exact: true,
    component: TestPage,
    claims: ['all'],
    children: [],
  },
  ...routingCash,
  ...routingTask,
  ...routingContractor,
  ...routingSalary,
  ...routingDictionary,
  ...routingNomenclature,
  ...routingMaterialFlow,
  ...routingEmployees,
  ...routingSecurity,
  ...routingAccounts,
];
